export const ADD_MATERIAL_TYPE_SUCCESS = "ADD_MATERIAL_TYPE_SUCCESS";
export const CREATE_MATERIAL_TYPE_SUCCESS = "CREATE_MATERIAL_TYPE_SUCCESS";
export const LIST_ALL_MATERIAL_TYPES_REQUEST = "LIST_ALL_MATERIAL_TYPES_REQUEST";
export const LIST_ALL_MATERIAL_TYPES_SUCCESS = "LIST_ALL_MATERIAL_TYPES_REQUEST_SUCCESS";
export const LIST_ALL_MATERIAL_TYPES_FAILURE = "LIST_ALL_MATERIAL_TYPES_FAILURE";
export const UPDATE_MATERIAL_TYPE_SUCCESS = "UPDATE_MATERIAL_TYPE_SUCCESS";
export const DELETE_MATERIAL_TYPE_SUCCESS = "DELETE_MATERIAL_TYPE_SUCCESS";
